<script lang="ts">
	import CartProvider from '$lib/components/cart/store.svelte';
	import { m } from '$lib/paraglide/messages.js';
	import { getContext } from 'svelte';

	const cart = getContext<CartProvider>('cart');
</script>

<a aria-label={m.cart()} href="/cart" class="relative block">
	<div class="icon-[mdi--cart] block size-full"></div>

	{#if cart.itemsQuantity > 0}
		<span
			class="absolute top-0 right-0 flex size-1/2 items-center justify-center rounded-full bg-red-500 text-xs text-white"
		>
			{cart.itemsQuantity}
		</span>
	{/if}
</a>
